export default {"src":"/_next/static/media/threads-logo.aa8ca7d8.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};